import React from 'react';

const Loadable = React.lazy(() => import('../../pages/Crisp/Crisp'));

export default Loadable;
